<template>
  <v-dialog v-model="input">
    <v-card class="rounded-xl">
      <v-card-title class="d-flex justify-space-between"
        ><div>Import CSV</div>
        <div>
          <v-btn
            rounded
            depressed
            color="warning"
            @click="addExpenses"
            :disabled="expenses.length == 0"
            :loading="isLoading"
            ><i class="fa-solid fa-upload mr-1"></i>Import</v-btn
          >
        </div></v-card-title
      >
      <v-card-text>
        <v-file-input
          rounded
          outlined
          dense
          label="CSV File"
          v-model="file"
          @change="readFile()"
        ></v-file-input>
        <v-data-table
          mobile-breakpoint="0"
          :headers="headers"
          :items="expenses"
          :items-per-page="15"
          class="elevation-0"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td>$ {{ convertToCleanNumber(item.amount) }}</td>
              <td>{{ getOptionName(item.typeId) }}</td>
              <td>{{ getOptionName(item.vendorId) }}</td>
              <td>{{ getOptionName(item.paymentMethodId) }}</td>
              <td>{{ item.transactionDate }}</td>
              <td>{{ item.description }}</td>
            </tr>
          </template></v-data-table
        >
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import { ExpenseVendor, ExpensePayment, ExpenseType } from "@/js/enum.js";
import generalMixin from "@/js/general-mixin.js";
import backendService from "@/services/backend-service.js";
import Decimal from "decimal.js";
export default {
  name: "InStockDialog",
  mixins: [generalMixin],
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialog: true,
      file: null,
      expenses: [],
      fileContent: "",
      isLoading: false,
      headers: [
        { text: "Amount", value: "amount", width: 100 },
        { text: "Type", value: "typeId", width: 100 },
        { text: "Vendor", value: "vendorId", width: 100 },
        { text: "Payment Method", value: "paymentMethodId", width: 100 },
        { text: "Transaction Date", value: "transactionDate", width: 150 },
        { text: "Description", value: "description", width: 200 },
      ],
    };
  },
  computed: {
    input: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  created: function () {},

  methods: {
    addExpenses() {
      if (this.expenses.length == 0) return;
      this.isLoading = true;
      backendService
        .addExpenses(this.expenses)
        .then(() => {
          this.timer(1000).then(() => {
            this.isLoading = false;
            this.file = null;
            this.fileContent = "";
            this.expenses = [];
            this.successSnackbar("Successfully imported CSV file");
            this.dialog = false;
          });
        })
        .catch(() => {
          this.timer(1000).then(() => {
            this.errorSnackbar("Ops! Something is not right");
            this.isLoading = false;
          });
        });
    },
    setDialog() {
      this.input = false;
      this.$emit("handle-event");
    },
    readFile() {
      if (!this.file) return;

      const reader = new FileReader();
      reader.onload = (e) => {
        this.fileContent = e.target.result;
        let rawRows = this.fileContent.split("\r\n");
        for (let i = 0; i < rawRows.length; i++) {
          let rawRow = rawRows[i].split(",");
          if (rawRow[0].length == 0) continue;
          let expense = {};
          let dateArr = rawRow[0].split("/");

          let amount = new Decimal(rawRow[1]);
          expense.transactionDate = new Date(
            `${dateArr[2]}-${dateArr[0]}-${dateArr[1]}`
          );
          expense.amount = amount.mul(-1);
          expense.vendorId = this.getIdByEnum(ExpenseVendor.Other);
          expense.typeId = this.getIdByEnum(ExpenseType.Other);
          expense.paymentMethodId = this.getIdByEnum(
            ExpensePayment.DebitCredit
          );
          expense.description = rawRow[4];
          this.expenses.push(expense);
        }
      };
      reader.readAsText(this.file);
    },
  },
  watch: {},
};
</script>
<style scoped></style>
